export default {
  path: '/subscriptions',
  name: 'subscriptions',
  component: () => import('../components/subscription/Layout.vue'),
  redirect: { name: 'SubscriptionList' },
  children: [
    {
      name: 'SubscriptionList',
      path: '',
      component: () => import('../views/subscription/List.vue'),
      meta: {
        listPage: true
      }
    },
    {
      name: 'SubscriptionCreate',
      path: 'new/:parent?',
      component: () => import('../views/subscription/Create.vue'),
      meta: {
        createPage: true
      }
    },
    {
      name: 'SubscriptionUpdate',
      path: ':id/edit',
      component: () => import('../views/subscription/Update.vue'),
      meta: {
        updatePage: true
      }
    }
  ],
  meta: {
    admin: true
  }
};
